export default __webpack_public_path__ + "static/05_PchelkasStarryJourney-5f3106463bef9cdc67395068193e3a81.pdf";